import DailyDesignLogo from 'assets/icons/daily-design-logo.png';
import { NewsletterSidebar } from 'components/newsletter/newsletter-sidebar-component';
import { Post } from 'components/post/post-component';
import ReactSquadAdBanner from 'components/reactsquadad/react-squad-ad-banner';
import { Typography } from 'components/typography/typography-component';
import { htmlToText } from 'html-to-text';

import { SidebarPost, SidebarProps } from './sidebar-types';

const SidebarComponent = ({ posts, postTitle, categorySlug }: SidebarProps) => {
  return (
    <div className=" flex h-full w-full flex-col gap-7 border-slate-50 px-6 lg:border-l-2 lg:pr-0">
      <Typography
        variant="h2"
        className="mb-6 border-b-2 border-black text-[1.8rem]"
      >
        {htmlToText(postTitle)}
      </Typography>
      {posts.map((post: SidebarPost, index) => (
        <Post
          key={index}
          description=""
          variant="horizontal_count"
          count={`${index + 1}`}
          title={post.title}
          img={post.img ?? ''}
          link={`/${categorySlug}/${post.slug}`}
        />
      ))}
      <hr className="my-5 border-slate-50" />

      <ReactSquadAdBanner />

      <hr className="my-5 border-slate-50" />
    </div>
  );
};

export default SidebarComponent;
